module.exports = __webpack_public_path__ + "img/login.a1dd2c09.png";